import styled from '@style'

const PageContainer = styled.main`
  overflow: hidden;
`

export { PageContainer }
